import userRoutes from "./User";

const userRoutesMap = {
  ...userRoutes,
};

export default userRoutesMap;
